import { DKON_THEME } from "./DKON"
import { TTDK_THEME } from "./TTDK"
import { HCMTAX_THEME } from './HCMTAX'
import { TAMOVE_THEME } from './TAMOVE'

const themeName = process.env.REACT_APP_THEME_NAME
let themeIcons=TTDK_THEME
switch(themeName){
  case 'DKON':
    themeIcons=DKON_THEME
    break
  case 'TTDK':
    themeIcons=TTDK_THEME
    break
  case 'HCMTAX':
    themeIcons=HCMTAX_THEME
    break
  case 'TAMOVE':
    themeIcons=TAMOVE_THEME
    break
  default:
    themeIcons=TTDK_THEME
}

export default themeIcons
